import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IOrderCardAction, IOrderCardData } from 'models/orders/ordercard';
import { ErrorPage } from 'containers';
import { getProductCard } from 'redux/modules/product/productcard';
import { IProductCardDataAction } from 'models/product/productcard';
import { getOrder, clearData } from 'redux/modules/user/ordercard';
import { OrderDetails } from '../../Common/OrderDetails';
require('./style.css');

interface IProps {
	orderCard?: IOrderCardData;
	id?: string;
	userId?: string;
	params?: IParams;
	userLanguageKey?: number;

	/* functions props */
	getOrder?: (id: string) => IOrderCardAction;
	clearData?: () => IOrderCardAction;
	getProductCard?: (id: string, target: string) => IProductCardDataAction;
	t?: (key: string) => string;
}

interface IParams {
	id?: string;
}

@connect(
	(state: IStore) => ({
		orderCard: state.orderCard,
		userId: state.userPreferences.id,
		userLanguageKey: state.userPreferences.languageKey,
	}),
	(dispatch) => ({
		getOrder: (id: string) => dispatch(getOrder(id)),
		getProductCard: (id: string, target: string) => dispatch(getProductCard(id, target)),
		clearData: () => dispatch(clearData()),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserOrderCard extends React.Component<IProps, any> {
	public componentDidMount() {
		if (this.props?.userLanguageKey) {
			this.props.getOrder(this.props.params.id);
		}
	}

	public componentDidUpdate(prevProps: Readonly<IProps>) {
		// Prevent from fetching before moment().locale(culture) is set because otherwise we get the wrong locale and display the wrong language
		// could be a deeper issue in timings of the calls if the problem appears elsewhere
		if (!prevProps?.userLanguageKey && this.props?.userLanguageKey) {
			this.props.getOrder(this.props.params.id);
		}
	}

	public componentWillUnmount() {
		this.props.clearData();
	}

	public render() {
		const { userId } = this.props;

		if (this.props.orderCard.error) {
			return <ErrorPage {...this.props} message={this.props.orderCard.message} />;
		}

		return (
			<div className="userOrderCard">
				<OrderDetails
					orderCard={this.props.orderCard}
					viewType="user"
					backLink={`/profile/${userId}?tab=appointments`}
				/>
			</div>
		);
	}
}
export { UserOrderCard };
